if (!customElements.get("personalisation-box")) {
  customElements.define(
    "personalisation-box",
    class PersonalisationBox extends HTMLElement {
      constructor() {
        super();

        this.letterVariants = JSON.parse(
          this.querySelector('[type="application/json"]').textContent.replace(
            /,\s*]/,
            "]"
          )
        );

        this.minimumPrice = this.querySelector("#letters-minimum-price");
        this.livePrice = this.querySelector("#letters-live-price");
        this.options = this.querySelector("#letters-options");
        this.inputBox = this.querySelector("#letters-input");
        this.inputErrors = this.querySelector("#letters-input-errors");
        this.addToCartButton = this.querySelector("#add-letters-to-cart");
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        this.registerEvents();

        this.MINIMUM_LETTERS_NEEDED = 3;
        this.MAXIMUM_LETTERS_ALLOWED = 12;
      }

      registerEvents() {
        this.options
          .querySelectorAll("input")
          .forEach((input) =>
            input.addEventListener("click", this.handleUserInput.bind(this))
          );

        this.inputBox.addEventListener(
          "input",
          this.handleUserInput.bind(this)
        );

        this.addToCartButton.addEventListener(
          "click",
          this.handleAddToCart.bind(this)
        );
      }

      handleUserInput() {
        this.validateInput();
        this.updatePrice();
      }

      updatePrice() {
        if (
          this.inputBox.value.length >= this.MINIMUM_LETTERS_NEEDED &&
          this.inputBox.value.length <= this.MAXIMUM_LETTERS_ALLOWED
        ) {
          const { validVariantPrices } = this.extractLetterData();
          const sumPrice = validVariantPrices.reduce(
            (total, item) => total + item.price,
            0
          );
          const sumCompareAtPrice = validVariantPrices.reduce(
            (total, item) => total + item.compare_at_price,
            0
          );

          this.minimumPrice.classList.add("hidden");
          this.livePrice.classList.remove("hidden");
          this.livePrice.querySelector("#live-price").textContent =
            Shopify.formatMoney(sumPrice) + ` ${Shopify.currency.active}`;

          if (Number(sumCompareAtPrice) > Number(sumPrice)) {
            this.livePrice.querySelector("#live-compare-at").textContent =
              Shopify.formatMoney(sumCompareAtPrice) +
              ` ${Shopify.currency.active}`;
          } else {
            this.livePrice
              .querySelector("#live-compare-at")
              .classList.add("hidden");
          }
        } else {
          this.livePrice.classList.add("hidden");
          this.minimumPrice.classList.remove("hidden");
        }
      }

      handleAddToCart() {
        const { validIds } = this.extractLetterData();

        if (!validIds.length) {
          alert("Please enter valid name.");
          return;
        }

        const cartReadyItems = validIds.map((id) => {
          return {
            id,
            quantity: 1,
          };
        });

        const formData = {
          items: cartReadyItems,
          sections: this.cart
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
        };

        this.cart.setActiveElement(document.activeElement);

        this.addToCartButton.setAttribute("disabled", true);
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.log(response.description);
              this.addToCartButton.setAttribute("disabled", true);
              this.querySelector("span").classList.add("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error)
              this.addToCartButton.removeAttribute("disabled", true);
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            this.inputBox.value = "";
            this.inputErrors.textContent = "";
            this.livePrice.classList.add("hidden");
            this.minimumPrice.classList.remove("hidden");
          });
      }

      extractLetterData() {
        let validIds = [];
        let validVariantPrices = [];
        let variantAvailability = [];

        const lettersToAdd = this.inputBox.value.split("");
        const uppercaseLetters = lettersToAdd.map((letter) =>
          letter.toUpperCase()
        );
        const selectedVariant = this.querySelector(
          ".product-form__input input:checked"
        ).value;

        for (let i = 0; i < uppercaseLetters.length; i++) {
          const letter = uppercaseLetters[i];

          for (let j = 0; j < this.letterVariants.length; j++) {
            const variantName = this.letterVariants[j].name;
            if (
              variantName.includes(selectedVariant) &&
              variantName.includes(`Letter ${letter}`)
            ) {
              const variantId = this.letterVariants[j].id;
              const variantAvailable = {
                letterName: letter,
                variantName: selectedVariant,
                available: this.letterVariants[j].available,
              };
              const variantPrices = {
                price: this.letterVariants[j].price,
                compare_at_price: this.letterVariants[j].compare_at_price,
              };

              validIds.push(variantId);
              validVariantPrices.push(variantPrices);
              variantAvailability.push(variantAvailable);
            }
          }
        }

        return { validIds, validVariantPrices, variantAvailability };
      }

      validateInput(value) {
        const { variantAvailability } = this.extractLetterData();
        const unavailableVariant = variantAvailability.find(
          (letter) => letter.available === false
        );
        const atLeastOneUnavailable = Boolean(unavailableVariant);

        this.inputBox.value = this.inputBox.value.replace(/[^a-zA-Z]/g, "");

        if (this.inputBox.value.length < this.MINIMUM_LETTERS_NEEDED) {
          this.inputErrors.textContent = `Minimum ${this.MINIMUM_LETTERS_NEEDED} letters required.`;
          this.addToCartButton.setAttribute("disabled", true);
        } else if (this.inputBox.value.length > this.MAXIMUM_LETTERS_ALLOWED) {
          this.inputErrors.textContent = `Maximum ${this.MAXIMUM_LETTERS_ALLOWED} letters allowed.`;
          this.inputBox.value = this.inputBox.value.slice(0, this.MAXIMUM_LETTERS_ALLOWED);
        } else {
          if (atLeastOneUnavailable) {
            this.inputErrors.textContent = `Letter ${unavailableVariant.letterName}/${unavailableVariant.variantName} is currently sold out.`;
            this.addToCartButton.setAttribute("disabled", true);
            return;
          }

          this.inputErrors.textContent = "";
          this.addToCartButton.removeAttribute("disabled");
        }
      }
    }
  );
}
